// USPTO Technology Centers and Group Art Units
// Source: USPTO classification structure
export const artUnits = [
  // Technology Center 1600: Biotechnology and Organic Chemistry
  { code: '1600', description: 'Biotechnology and Organic Chemistry' },
  { code: '1610', description: 'Protein and Molecular Biology' },
  { code: '1620', description: 'Organic Chemistry' },
  { code: '1630', description: 'Chemistry of Carbon Compounds' },
  { code: '1640', description: 'Peptides, Proteins, and Molecular Biology' },
  { code: '1650', description: 'Organic Chemistry - Macromolecular' },
  { code: '1660', description: 'Organic Chemistry - Heterocyclic' },
  
  // Technology Center 1700: Chemical and Materials Engineering
  { code: '1700', description: 'Chemical and Materials Engineering' },
  { code: '1710', description: 'Inorganic Chemistry' },
  { code: '1720', description: 'Organic Chemistry - Compounds' },
  { code: '1730', description: 'Chemical and Materials Engineering' },
  { code: '1740', description: 'Organic Chemistry' },
  { code: '1750', description: 'Chemical Engineering' },
  { code: '1760', description: 'Materials Science' },
  { code: '1770', description: 'Semiconductor Device Manufacturing' },
  { code: '1780', description: 'Chemical Engineering and Materials Science' },
  { code: '1790', description: 'Physical Chemistry' },
  
  // Technology Center 2100: Computer Architecture and Software
  { code: '2100', description: 'Computer Architecture, Software, and Information Security' },
  { code: '2110', description: 'Computer Architecture and Software' },
  { code: '2120', description: 'Computer Networks and Security' },
  { code: '2130', description: 'Data Processing and Database Management' },
  { code: '2140', description: 'Computer Graphics and Image Processing' },
  { code: '2150', description: 'Information Security' },
  { code: '2160', description: 'Computer Architecture' },
  { code: '2170', description: 'Software Engineering' },
  { code: '2180', description: 'Artificial Intelligence and Machine Learning' },
  { code: '2190', description: 'Distributed Computing' },
  
  // Technology Center 2400: Computer Networks, Multiplex, Cable, and Security
  { code: '2400', description: 'Computer Networks, Multiplex, Cable, and Security' },
  { code: '2410', description: 'Telephony and Wireless Communications' },
  { code: '2420', description: 'Computer Networks and Protocols' },
  { code: '2430', description: 'Multiplex Communications' },
  { code: '2440', description: 'Cable Communications and TV Systems' },
  { code: '2450', description: 'Cryptography and Security' },
  { code: '2460', description: 'Network Architecture' },
  { code: '2470', description: 'Telecommunications' },
  { code: '2480', description: 'Satellite Communications' },
  { code: '2490', description: 'Video and Audio Streaming' },
  
  // Technology Center 2600: Communications
  { code: '2600', description: 'Communications' },
  { code: '2610', description: 'Pulse and Digital Communications' },
  { code: '2620', description: 'Radio Communications' },
  { code: '2630', description: 'Telecommunications' },
  { code: '2640', description: 'Harmonics, Modulation, and Pulse Communications' },
  { code: '2650', description: 'Multiplex Communications' },
  { code: '2660', description: 'Television and Facsimile' },
  { code: '2670', description: 'Optical Communications' },
  { code: '2680', description: 'Signaling and Antennas' },
  { code: '2690', description: 'Wireless Communication Systems' },
  
  // Technology Center 2800: Semiconductors, Electrical, and Optical Systems
  { code: '2800', description: 'Semiconductors, Electrical and Optical Systems and Components' },
  { code: '2810', description: 'Semiconductor Device Manufacturing' },
  { code: '2820', description: 'Semiconductor Devices' },
  { code: '2830', description: 'Semiconductor Memory Devices' },
  { code: '2840', description: 'Optical Systems and Elements' },
  { code: '2850', description: 'Semiconductor Materials and Processes' },
  { code: '2860', description: 'Semiconductor Testing and Packaging' },
  { code: '2870', description: 'Electrical Resistors and Capacitors' },
  { code: '2880', description: 'Luminescent Materials' },
  { code: '2890', description: 'Optical Recording and Display Systems' },
  
  // Technology Center 3600: Transportation, Construction, Electronic Commerce, Agriculture
  { code: '3600', description: 'Transportation, Construction, Electronic Commerce, Agriculture' },
  { code: '3610', description: 'Aeronautics and Propulsion' },
  { code: '3620', description: 'Land Vehicles and Transportation' },
  { code: '3630', description: 'Mechanical Engineering' },
  { code: '3640', description: 'Electronic Commerce and Business Methods' },
  { code: '3650', description: 'Construction and Earth Working' },
  { code: '3660', description: 'Agriculture and Horticulture' },
  { code: '3670', description: 'Material Handling' },
  { code: '3680', description: 'Mechanical Power Systems' },
  { code: '3690', description: 'Machine Tools and Metal Working' },
  
  // Technology Center 3700: Mechanical Engineering, Manufacturing, and Products
  { code: '3700', description: 'Mechanical Engineering, Manufacturing, and Products & Design' },
  { code: '3710', description: 'Fluid Dynamics and Hydraulics' },
  { code: '3720', description: 'Material Processing and Handling' },
  { code: '3730', description: 'Mechanical Engineering' },
  { code: '3740', description: 'Industrial and Manufacturing Processes' },
  { code: '3750', description: 'Machine Elements and Mechanisms' },
  { code: '3760', description: 'Tools and Hardware' },
  { code: '3770', description: 'Design and Ornamentation' },
  { code: '3780', description: 'Textiles and Fabrics' },
  { code: '3790', description: 'Consumer Products' },
];

export default artUnits;
